(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/correction-email/assets/javascripts/correction-email.js') >= 0) return;  svs.modules.push('/components/tur/correction-email/assets/javascripts/correction-email.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.tur = svs.tur || {};
const logger = new svs.core.log.Logger('tur:correction-email');
const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
svs.tur.CorrectionEmail = function (_options) {
  let options = {
    productName: '',
    callback: undefined
  };
  options = _objectSpread(_objectSpread({}, options), _options);
  const numberProducts = ['Eurojackpot', 'Vikinglotto', 'Lotto', 'Keno'];
  function failedToSaveCorrectionEmail() {
    const message = 'Det gick tyvärr inte att spara din inställning för rättningsmail.';
    const errorDialog = new svs.ui.dialog.Confirm({
      type: svs.ui.dialog.type.ERROR,
      title: 'Tekniskt fel',
      branding: svs.ui.dialog.branding.TUR,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: message
      }],
      actions: [{
        type: svs.ui.dialog.button.PRIMARY,
        title: 'Okej'
      }]
    });
    svs.ui.dialog.api.add(errorDialog);
  }
  async function postToObjectStore(_ref) {
    let {
      key,
      value,
      expires
    } = _ref;
    try {
      await drawgamesApiCaller.postPlayerObjectstore({
        key,
        value,
        expires
      });
    } catch (error) {
      failedToSaveCorrectionEmail();
    }
  }
  async function getObjectStoreData(_ref2) {
    let {
      key
    } = _ref2;
    try {
      var _objectStoreResponse$;
      const objectStoreResponse = await drawgamesApiCaller.getPlayerObjectstore({
        keys: key
      });
      const item = (_objectStoreResponse$ = objectStoreResponse.response) === null || _objectStoreResponse$ === void 0 || (_objectStoreResponse$ = _objectStoreResponse$.items) === null || _objectStoreResponse$ === void 0 ? void 0 : _objectStoreResponse$.find(item => item.key === key);
      const hasValue = Boolean(item && item.value);
      return hasValue;
    } catch (e) {
      return false;
    }
  }


  async function setCorrectionEmailDialogShown() {
    var _svs$accountservices, _options$callback, _options2;
    const ONE_MONTH_IN_SECONDS = svs.components.Storage.constants.EXPIRES_1MONTH * 60;
    (_svs$accountservices = svs.accountservices) === null || _svs$accountservices === void 0 || (_svs$accountservices = _svs$accountservices.player_notifications_checker) === null || _svs$accountservices === void 0 || (_svs$accountservices = _svs$accountservices.events) === null || _svs$accountservices === void 0 || _svs$accountservices.trigger('email');
    await postToObjectStore({
      key: 'correctionEmailShown',
      value: 'true',
      expires: ONE_MONTH_IN_SECONDS
    });
    (_options$callback = (_options2 = options).callback) === null || _options$callback === void 0 || _options$callback.call(_options2);
  }

  async function toggleCorrectionEmailOn() {
    const settings = numberProducts.map(product => ({
      key: "correctionMail".concat(product),
      value: true
    }));
    try {
      await drawgamesApiCaller.putPlayerSettings({
        settings
      });
    } catch (error) {
      failedToSaveCorrectionEmail();
    }
  }

  function showDialog() {
    const signUpDialog = new svs.ui.dialog.Confirm({
      icon: 'e-post',
      branding: svs.ui.dialog.branding.TUR,
      requireHandshake: true,
      title: 'Önskar du en personlig rättningsupplevelse till din e-post?',
      actions: [{
        type: svs.ui.dialog.button.SECONDARY,
        title: 'Nej tack',
        callback: () => {
          setCorrectionEmailDialogShown();
          signUpDialog.resolveHandshake();
        }
      }, {
        type: svs.ui.dialog.button.SECONDARY,
        title: 'Ja tack',
        showLoader: true,
        callback: async () => {
          await toggleCorrectionEmailOn();
          await setCorrectionEmailDialogShown();
          signUpDialog.resolveHandshake();
        }
      }]
    });
    svs.ui.dialog.api.add(signUpDialog);
  }

  async function show() {
    try {
      var _settingsResponse$res;
      const hasShownCorrectionEmailDialog = await getObjectStoreData({
        key: 'correctionEmailShown'
      });
      if (hasShownCorrectionEmailDialog) {
        var _options$callback2, _options3;
        (_options$callback2 = (_options3 = options).callback) === null || _options$callback2 === void 0 || _options$callback2.call(_options3);
        return;
      }
      const settingsResponse = await drawgamesApiCaller.getPlayerSettings();
      const settings = ((_settingsResponse$res = settingsResponse.response) === null || _settingsResponse$res === void 0 ? void 0 : _settingsResponse$res.settings) || {};
      const isCorrectionEmailEnabled = numberProducts.some(product => settings["correctionMail".concat(product)]);
      if (isCorrectionEmailEnabled) {
        var _options$callback3, _options4;
        (_options$callback3 = (_options4 = options).callback) === null || _options$callback3 === void 0 || _options$callback3.call(_options4);
        return;
      }
      showDialog();
    } catch (error) {
      logger.error('Error fetching player settings', error);
    }
  }
  return {
    show,
    SHOW_DIALOG_TEST_ONLY: showDialog
  };
};

 })(window);